module.exports = __webpack_public_path__ + "img/labs2_1.3bc83603.svg";